import React from 'react';
import { Section } from './ui/Section';
export function NewUrgency() {
  return <Section className="bg-cream py-16 border-y-2 border-honey/40" data-id="element-366">
      <div className="max-w-3xl mx-auto text-center space-y-12" data-id="element-367">
        <div data-id="element-368">
          <h3 className="text-xl font-bold text-terracotta mb-4 uppercase tracking-wider" data-id="element-369">
            ⚠️ PRECIO DE LANZAMIENTO — LIMITADO
          </h3>
          <p className="text-forest/80 leading-relaxed" data-id="element-370">
            Este es el precio especial de lanzamiento de Hogar Natural en Casa.
            Una vez que terminemos esta etapa inicial el precio va a subir. Si
            estás viendo esto ahora es porque todavía estás a tiempo de entrar
            al precio más bajo que va a tener este sistema. No lo dejes para
            mañana. Mañana puede costar más.
          </p>
        </div>

        <div data-id="element-371">
          <h3 className="text-xl font-bold text-forest-deep mb-4 uppercase tracking-wider" data-id="element-372">
            🕐 ACCESO INMEDIATO
          </h3>
          <p className="text-forest/80 leading-relaxed" data-id="element-373">
            En menos de 2 minutos después de tu compra ya tenés todo el sistema
            descargado en tu teléfono o computadora. Listo para usar esta misma
            noche.
          </p>
        </div>
      </div>
    </Section>;
}